import Fonts from '../../../../shared/assets/style/default/fonts';
import styled from 'styled-components';

const Bold = styled.span<React.CSSProperties>`
  font-family: ${Fonts['bold']};
`;

export default Bold;
